var _a;
import * as tslib_1 from "tslib";
import { reduxKey } from './constants';
import { StreamType } from './types';
import { STREAM__DELETE_STREAM } from './base/actions';
import withPaginationStreamReducer from './withPagination/reducer';
import withCursorStreamReducer from './withCursor/reducer';
import withOffsetStreamReducer from './withOffset/reducer';
var defaultState = {};
var reducers = (_a = {},
    _a[reduxKey] = function (state, action) {
        var _a;
        if (state === void 0) { state = defaultState; }
        var type = action.type;
        var _b = action.payload
            ? action.payload
            : action, streamId = _b.streamId, actionStreamType = _b.streamType;
        if (!streamId) {
            return state;
        }
        var _c = streamId, streamState = state[_c], rest = tslib_1.__rest(state, [typeof _c === "symbol" ? _c : _c + ""]);
        if (type === STREAM__DELETE_STREAM) {
            return rest;
        }
        var streamType = actionStreamType || (streamState && streamState.streamType);
        var newStreamState;
        switch (streamType) {
            case StreamType.WITH_CURSOR:
                newStreamState = withCursorStreamReducer(streamState, action);
                break;
            case StreamType.WITH_PAGINATION:
                newStreamState = withPaginationStreamReducer(streamState, action);
                break;
            case StreamType.WITH_OFFSET:
                newStreamState = withOffsetStreamReducer(streamState, action);
                break;
            default:
                return state;
        }
        if (newStreamState === streamState) {
            return state;
        }
        return tslib_1.__assign({}, state, (_a = {}, _a[streamId] = newStreamState, _a));
    },
    _a);
export default reducers;
export { reduxKey };
//# sourceMappingURL=reducers.js.map